import React from "react";
import LeaveWorkflowEditor from "./LeaveWorkflowEditor";
import {
  isSeparateWorkflowEnabled,
  normalizeLeaveTypeApprovalWorkflow,
} from "../../../../lib/leaveApprovalWorkflow";

const labelCls = (darkMode) =>
  `block text-sm font-medium mb-1 ${darkMode ? "text-gray-300" : "text-gray-700"}`;

const selectCls = (darkMode) =>
  `w-full p-2 border rounded text-sm ${
    darkMode ? "bg-gray-700 border-gray-600 text-white" : "bg-white border-gray-300"
  }`;

const LeaveTypeApprovalWorkflowSection = ({
  darkMode,
  cfg,
  leaveTypeId,
  leaveTypeRequiresApproval = true,
  updateLeaveTypeConfig,
}) => {
  const approval = cfg.approvalWorkflow || {};
  const separateEnabled = isSeparateWorkflowEnabled(approval);
  const separateOption = separateEnabled ? "Yes" : "No";

  const setApproval = (patch) => {
    updateLeaveTypeConfig(leaveTypeId, "approvalWorkflow", {
      ...approval,
      ...patch,
    });
  };

  const handleSeparateOptionChange = (value) => {
    const isYes = value === "Yes";
    if (isYes) {
      const normalized = normalizeLeaveTypeApprovalWorkflow({
        ...approval,
        enableSeparateWorkflow: "Yes",
      });
      updateLeaveTypeConfig(leaveTypeId, "approvalWorkflow", normalized);
    } else {
      setApproval({ enableSeparateWorkflow: "No" });
    }
  };

  const workflowForEditor = normalizeLeaveTypeApprovalWorkflow(approval);

  return (
    <div className="mb-4">
      <h4 className="text-md font-medium mb-3">Approval Workflow</h4>

      <div className="mb-4 max-w-md">
        <label className={labelCls(darkMode)}>
          Do you want a separate workflow for this leave type?
        </label>
        <select
          value={separateOption}
          onChange={(e) => handleSeparateOptionChange(e.target.value)}
          className={selectCls(darkMode)}
        >
          <option value="No">No</option>
          <option value="Yes">Yes</option>
        </select>
      </div>

      {!leaveTypeRequiresApproval && (
        <p className={`text-sm mb-3 ${darkMode ? "text-gray-400" : "text-gray-500"}`}>
          This leave type is configured as not requiring approval (Create/Edit Leave Type).
          Requests will be auto-approved.
        </p>
      )}

      {leaveTypeRequiresApproval && separateOption === "No" && (
        <p className={`text-sm ${darkMode ? "text-gray-400" : "text-gray-500"}`}>
          This leave type uses the leave group workflow. Select &quot;Yes&quot; above to
          configure a workflow specific to this leave type.
        </p>
      )}

      {leaveTypeRequiresApproval && separateOption === "Yes" && (
        <LeaveWorkflowEditor
          darkMode={darkMode}
          workflow={workflowForEditor}
          onChange={(nextWorkflow) => {
            updateLeaveTypeConfig(leaveTypeId, "approvalWorkflow", {
              enableSeparateWorkflow: "Yes",
              ...nextWorkflow,
            });
          }}
          autoApprovedMessage="Requests using this workflow method will be auto-approved when Approval Method is set to Auto approved."
        />
      )}
    </div>
  );
};

export default LeaveTypeApprovalWorkflowSection;
